import React from 'react';
import * as ReactRouterDom from 'react-router-dom';
import { ServiceProvider } from 'services';
import { StoreProvider } from 'store';
import { ThemeProvider } from 'theming';
import { IntlProvider } from 'app/IntlProvider';

const BrowserRouter = ReactRouterDom.BrowserRouter as unknown as React.FC<{
  children?: React.ReactNode;
}>;

export const GlobalProvider: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => (
  <BrowserRouter>
    <StoreProvider>
      <ServiceProvider>
        <IntlProvider>
          <ThemeProvider>{children}</ThemeProvider>
        </IntlProvider>
      </ServiceProvider>
    </StoreProvider>
  </BrowserRouter>
);
